<template>
    <div class="" style="direction: rtl">
        <div class="p-p-4 p-grid">
            <Accordion class="flex-grow-1 flex" :multiple="true">
                <AccordionTab header="נושאי שיעור">
                    <SubjectTable class="p-shadow-1"></SubjectTable>
                </AccordionTab>
                <AccordionTab header="סוגי נוכחות">
                    <PresenceStatusTable></PresenceStatusTable>
                </AccordionTab>
                <AccordionTab header="אירועי משמעת">
                    <SubjectTracingTable class=" p-shadow-1"></SubjectTracingTable>
                </AccordionTab>
                <AccordionTab header="זמני שיעורים">
                    <LessonTimeTable class="p-shadow-1"></LessonTimeTable>

                </AccordionTab>
                <AccordionTab header="כיתות">
                    <GradeTable class=" p-shadow-1"></GradeTable>
                </AccordionTab>
                <AccordionTab header="זמני מערכת">
                    <dates-system></dates-system>
                </AccordionTab>
                <AccordionTab header="זמני תעודות">
                    <dates-range-report/>
                </AccordionTab>
                <AccordionTab header="הגדים לתעודה">
                    <report-ratings-subject/>
                </AccordionTab>
                <AccordionTab header="הודעות מערכת">
                    <system-messages/>
                </AccordionTab>
                <AccordionTab header="החלפת כיתות">
                    <grade-changes/>
                </AccordionTab>
                <AccordionTab header="קישורעם חיצוניים">
                    <external-link-table/>
                </AccordionTab>
                <AccordionTab header="העלאת מידע">
                    <upload-data/>
                </AccordionTab>
            </Accordion>

        </div>

    </div>
</template>

<script>

import GradeTable from "../tables/adminTables/settingsTables/GradeTable";
import PresenceStatusTable from "../tables/adminTables/settingsTables/PresenceStatusTable";
import SubjectTable from "../tables/adminTables/settingsTables/SubjectTable";
import SubjectTracingTable from "../tables/adminTables/settingsTables/SubjectTracingTable";
import SystemMessages from "../tables/adminTables/settingsTables/SystemMessages/SystemMessages";
import LessonTimeTable from "../tables/adminTables/settingsTables/LessonTimeTable";
import DatesSystem from "@/tables/adminTables/settingsTables/datesSystem/DatesSystem.vue";
import ReportRatingsSubject from "@/tables/adminTables/settingsTables/ReportRatingsSubject/ReportRatingsSubject.vue";
import DatesRangeReport from "@/tables/adminTables/settingsTables/DatesRange/DatesRangeReport";
import ExternalLinkTable from "@/tables/adminTables/settingsTables/ExternalLinkTable";
import GradeChanges from "@/components/gradeChanges/GradeChanges.vue";
import UploadData from "@/components/upload/uploadData.vue";

export default {
    components: {
        UploadData,
        GradeChanges,
        DatesSystem,
        ReportRatingsSubject,
        GradeTable,
        PresenceStatusTable,
        ExternalLinkTable,
        SubjectTable,
        LessonTimeTable,
        SubjectTracingTable,
        DatesRangeReport,
        SystemMessages
    }
};
</script>


<style scoped>
.p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.country-item-value {
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.app-container {
    text-align: center;
}

.p-paginator {
    direction: rtl;
}

.p-paginator-icon {
    transform: scaleX(-1);
}

/*td {*/
/*  text-align: right !important;*/
/*}*/

p {
    text-align: right !important;
}

h4 {
    text-align: right !important;
}

/*::v-deep .row-unenabled {*/
/*  color: rgba(0, 0, 0, 0.3) !important;*/
/*}*/

th {
    text-align: right !important;
}
</style>
